import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'
import { MatMenuModule } from '@angular/material/menu'
import { MatIcon } from '@angular/material/icon'

export interface ActionCellProps<DATA> {
  actions: {
    name: string | ((d: DATA) => string);
    onAction: (d: DATA) => void;
    only?: (d: DATA) => boolean;
    disabled?: (d: DATA) => boolean;
    sensitive?: boolean;
  }[];
}

@Component({
  imports: [MatMenuModule, MatIcon],
  styles: `
        :host {
            position: relative;
        }

        .menu-button {
          background: none;
          border: none;
          padding: 0;
          margin: 0;
          display: flex;
          justify-content: center;
          align-items: start;
          width: 100%;
          height: 100%;
        }

        .action.sensitive {
          color: red;
        }

        .btn-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          width: 100%;

          .icon-btn {
            padding: 0;
            margin: 0;
            width: 2rem;
            height: 2rem;
            line-height: 1.5rem;
            border: none;
            background: none;
            border-radius: 50%;

            &:hover {
              background: gainsboro;
            }

            &:disabled {
              opacity: 0.5;
              background: none;
            }

            mat-icon {
              width: 1.5rem;
              height: 2rem;
            }
          }
        }
    `,
  template: `
    @if(actions.length) {
    <mat-menu #menu="matMenu">
      @for (option of actions; track $index) {
      <button
        mat-menu-item
        class="action"
        (click)="option.onAction(params.data!)"
        [disabled]="option.disabled ? option.disabled(params.data!) : false"
        [class.sensitive]="option.sensitive"
      >
        {{ getDisplay(option.name, params.data!) }}
      </button>
      }
    </mat-menu>
    <button class="menu-button" mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon svgIcon="more_horizontal"></mat-icon>
    </button>
    }
  `,
})
export class ActionCellComponent<DATA> extends BaseCellComponent<
  DATA,
  ActionCellProps<DATA>,
  keyof DATA
> {
  getDisplay(name: string | ((d: DATA) => string), d: DATA) {
    return typeof name === 'string' ? name : name(d)
  }

  get actions() {
    return this.params.actions.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (a) => !a.only || a.only(this.params.data as any),
    )
  }
}
